import React from 'react';
import LoadingScreen from '../layout/LoadingScreen';
import { reportClientError } from '../../utils/errorHandling';

class AppErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        reportClientError({ error, errorInfo }, 'AppErrorBoundary');
    }

    render() {
        if (this.state.hasError) {
            return <LoadingScreen text='Что-то пошло не так. Обновляем экран...' />;
        }

        return this.props.children;
    }
}

export default AppErrorBoundary;
